<script>
  import { createEventDispatcher } from 'svelte'
  import filterClasses, { updateClasses, cssPrefix } from '../helper-classes.js'

  export let id = null
  export let label = ''
  export let outlined = false
  export let transparent = false
  export let disabled = false
  export let tight = false
  export let icon = false
  export let loading = false
  export let light = false
  export let inverted = false
  export let status = 'primary'
  export let size = null
  export let type = 'button'
  export let title = null

  export let style = null
  export let helperClass = null
  let importedClasses = ''
  export { importedClasses as class }
  export let classPermissiveMode = false
  if (helperClass) {
    console.debug("[DS:deprecation] please replace 'helperClass' prop by 'class'")
    if (!importedClasses) {
      importedClasses = helperClass
    }
  }
  let classes = [`${cssPrefix}button`]
  if (importedClasses) classes.push(...filterClasses(importedClasses, classPermissiveMode))

  // TODO ? on:mouseover on:mouseenter on:mouseleave

  const dispatch = createEventDispatcher()

  if (![null, 'primary', 'success', 'info', 'warning', 'error', 'selected'].includes(status)) {
    console.debug(`[DS:Button] invalid status ${status}`)
  }

  if (![null, 'tiny', 'small', 'normal', 'medium', 'large'].includes(size)) {
    console.debug(`[DS:Button] invalid size ${size}`)
  } else if (size) {
    classes.push('size-' + size)
  }

  $: classes = updateClasses(classes, tight, 'is-tight')
  $: classes = updateClasses(classes, outlined, 'is-outlined')
  $: classes = updateClasses(classes, transparent, 'is-transparent')
  $: classes = updateClasses(classes, loading, 'is-loading')
  $: classes = updateClasses(classes, icon, 'is-icon')
  $: classes = updateClasses(classes, light, 'is-light')
  $: classes = updateClasses(classes, inverted, 'is-inverted')

  $: classes = updateClasses(classes, status, 'is-status-' + status, /^is-status/)

  function onClick(event) {
    if (loading) return
    dispatch('click', event)
  }

  const slots = $$slots
</script>

{#if slots && Object.prototype.hasOwnProperty.call(slots, 'default')}
  <button {type} class={classes.join(' ')} {style} {disabled} on:click|preventDefault={onClick} {id} {title}>
    <slot />
  </button>
{:else}
  <button {type} class={classes.join(' ')} {style} {disabled} on:click|preventDefault={onClick} {id} {title}
    >{label}</button
  >
{/if}
